import cheerUrl from "../../audio/cheer.mp3?url";
import { getSeVolume } from "./mixSettings.js";
import { getAudioContext } from "./audioContext.js";

/** Kept below the BGM/SE mix so a clear never startles the player. */
export const CLEAR_CHEER_VOLUME = 0.1;

/** Plays the supplied cheer once for each successfully completed case. */
export function playClearCheer(): void {
  if (typeof Audio === "undefined") return;

  const cheer = new Audio(cheerUrl);
  cheer.preload = "auto";
  cheer.volume = CLEAR_CHEER_VOLUME * getSeVolume();
  start(cheer);
}

function start(cheer: HTMLAudioElement): void {
  const volume = CLEAR_CHEER_VOLUME * getSeVolume();
  let source: MediaElementAudioSourceNode | null = null;
  let gain: GainNode | null = null;
  try {
    const context = getAudioContext();
    if (context) {
      source = context.createMediaElementSource(cheer);
      gain = context.createGain();
      gain.gain.value = volume;
      source.connect(gain).connect(context.destination);
      cheer.volume = 1;
      if (context.state === "suspended") void context.resume().catch(() => undefined);
    } else {
      cheer.volume = volume;
    }
    cheer.addEventListener("error", () => cheer.remove(), { once: true });
    cheer.addEventListener("ended", () => {
      source?.disconnect();
      gain?.disconnect();
      cheer.remove();
    }, { once: true });
    void cheer.play().catch(() => {
      source?.disconnect();
      gain?.disconnect();
      cheer.remove();
    });
  } catch {
    source?.disconnect();
    gain?.disconnect();
    cheer.remove();
  }
}
